import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { ClientFormComponent } from "./client-form/client.component";
import { MatRadioModule } from '@angular/material/radio';
import { ChildAbuseFormComponent } from "./child-abuse-form/child-abuse-form.component";
import { MaritalFormComponent } from "./marital-form/marital-form.component";
import { DomesticViolenceFormComponent } from "./domestic-violence-form/domestic-violence-form.component";
import { ChildrenFormComponent } from "./children-form/children-form.component";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { PsychologicalAbuseFormComponent } from "./psychological-abuse-form/psychological-abuse-form.component";
import { ProgressComponent } from "./dialog/progress/progress.component";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PhoneMaskDirective } from "../directives/phone-mask.directive";
import { SuccessComponent } from "./dialog/success/success.component";
import { MatDialogModule } from "@angular/material/dialog";
import { DateFormatDirective } from "../directives/date-placeholder.directive";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MovingPartyFormComponent } from "./moving-party-form/moving-party-form.component";
import { InformedConsentFormSignatureComponent } from "./informed-consent-form-signature/informed-consent-form-signature.component"
import { PhysicalViolenceFormComponent } from "./physical-violence-form/physical-violence-form.component"
import { InformationFormComponent } from "./information-form/information-form.component";
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LimitTextAreaDirective } from "../directives/limit-text-area.directive";
import { LettersOnlyDirective } from "../directives/letters-only.directive";

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatDialogModule,
    MatTooltipModule, MatDatepickerModule, MatNativeDateModule, MatCheckboxModule,
    MatRadioModule, MatProgressSpinnerModule, MatSelectModule, MatFormFieldModule],
  declarations: [InformationFormComponent, ClientFormComponent, ChildAbuseFormComponent, PsychologicalAbuseFormComponent,
    ProgressComponent, PhoneMaskDirective, SuccessComponent, DateFormatDirective, LimitTextAreaDirective, LettersOnlyDirective, 
    MaritalFormComponent, DomesticViolenceFormComponent, ChildrenFormComponent, HeaderComponent, FooterComponent,
    MovingPartyFormComponent, PhysicalViolenceFormComponent, InformedConsentFormSignatureComponent],
  exports: [InformationFormComponent, ClientFormComponent, ChildAbuseFormComponent, PsychologicalAbuseFormComponent,
    ProgressComponent, SuccessComponent, MaritalFormComponent, DomesticViolenceFormComponent,
    ChildrenFormComponent, HeaderComponent, FooterComponent,
    MovingPartyFormComponent, PhysicalViolenceFormComponent, InformedConsentFormSignatureComponent],
    entryComponents: [ProgressComponent, SuccessComponent]
})
export class ShareComponentModule {
    static forRoot(){
        return {
            ngModule: ShareComponentModule,
        }
    }
}
